import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';

const initState = {
    queryParams: {},
    dashboardSection: null,
    crmPath: {},
    selectedCrmModule: null,
    moduleSelectionMode: undefined //show-records,select
};

const setRouteParams = (state, action) => {//todo112

    return updateObject(state, { crmPath: action.payload.params });
}

const updateQueryParams = (state, action) => {//todo112

    return updateObject(state, { queryParams: action.payload.queryParams });
}

const updateDashboardSection = (state, action) => {//todo112

    return updateObject(state, { dashboardSection: action.payload.dashboardSection });
}

const setCrmModule = (state, action) => {
    return updateObject(state, { selectedCrmModule: action.payload.crmModule, moduleSelectionMode: action.payload.selectionMode })
}


const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionType.SET_ROUTE_PARAMS: return setRouteParams(state, action);
        case actionType.UPDATE_QUERY_PARAMS: return updateQueryParams(state, action);
        case actionType.UPDATE_DASHBOARD_SECTION: return updateDashboardSection(state, action);
        case actionType.SET_CRM_MODULE: return setCrmModule(state, action);
        default:
            return state
    }
}

export default reducer;